import { keyframes as r, styled as t } from "@lokalise/styled";
import { value as o } from "../../utils/theme/index.js";
const e = r`
    from {
        transform: translateX(-50%) translateY(-50%) rotate(0deg);
    }
    to {
        transform: translateX(-50%) translateY(-50%) rotate(360deg);
    }
`, n = t.div`
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: ${o("zIndex.loadingOverlay")};
`, d = t.div`
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background-color: ${o("color.background.surface.default")};
	z-index: ${o("zIndex.loadingOverlay")};
	opacity: 0.8;
`, l = t.div`
	position: absolute;
	top: 50%;
	left: 50%;
	width: 20px;
	height: 20px;
	border: 3px solid ${o("color.background.surface.fore")};
	border-bottom-color: ${o("color.background.action.primary.default")};
	border-radius: 50%;
	animation: ${e} 1s linear infinite;
	z-index: inherit;
`;
export {
  n as Container,
  d as Overlay,
  l as Spinner
};
//# sourceMappingURL=styles.js.map
